import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

export default function Section({
  title,
  icon,
  children,
  tip,
}: {
  title: React.ReactNode;
  icon: React.ReactNode;
  children: React.ReactNode;
  tip?: React.ReactNode;
}) {
  return (
    <Box
      sx={(theme) => ({
        background: "white",
        borderRadius: 10,
        padding: 4,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        [theme.breakpoints.down("sm")]: {
          padding: 2,
        },
      })}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {icon}
        <Typography variant="h6">{title}</Typography>
        <Box
          sx={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "text.secondary",
          }}
        >
          {tip}
        </Box>
      </Box>
      {children}
    </Box>
  );
}
